import { render, staticRenderFns } from "./LandingVideoAnimation.vue?vue&type=template&id=efad2df4&scoped=true"
import script from "./LandingVideoAnimation.vue?vue&type=script&lang=js"
export * from "./LandingVideoAnimation.vue?vue&type=script&lang=js"
import style0 from "./LandingVideoAnimation.vue?vue&type=style&index=0&id=efad2df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efad2df4",
  null
  
)

export default component.exports